export default "__VITE_PUBLIC_ASSET__0eddfb21__"